module.exports = __webpack_public_path__ + "img/syndrome.0bb6a6ea.svg";